import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Button, TextField, Typography } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import DashboardLogoutFooterComponent from '../footer/DashboardLogoutFooterComponent';
import AdminDashboardMenuHeaderComponent from './header/AdminDashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function AdminDashboardPool() {

    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    const karmaContext = useKarmaPoolContext();

    const [gbpInPool, setGbpInPool] = useState(() => {
        return karmaContext.local.pool.gbpInPool;
    });

    const [memberSlots, setMemberSlots] = useState(() => {
        return karmaContext.local.pool.memberSlots;
    });

    const [latestNewsletterId, setLatestNewsletterId] = useState(() => {
        return karmaContext.local.pool.latestNewsletterId;
    });

    useEffect(() => {
        setGbpInPool(karmaContext.local.pool.gbpInPool);
        setLatestNewsletterId(karmaContext.local.pool.latestNewsletterId);
    }, [karmaContext.local]);

    const handleGbpInPoolChange = (event) => {
        setGbpInPool(event.target.value);
    };

    const handleMemberSlotsChange = (event) => {
        setMemberSlots(event.target.value);
    };

    const handleLatestNewsletterIdChange = (event) => {
        setLatestNewsletterId(event.target.value);
    };

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();

        console.log("Setting GBP in pool to: " + gbpInPool);

        fetch(karmaContext.getURLBasePath() + 'pool', {
            method: 'PATCH',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                "gbpInPool": gbpInPool,
                "memberSlots": memberSlots,
                "latestNewsletterId": latestNewsletterId
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                karmaContext.refresh();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    RedirectIfNotLoggedIn();

    return (
        <>
            <Box className={karmaStyles.homepageBox}>
                <AdminDashboardMenuHeaderComponent
                    poolEnabled={true} />
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        Admin - Pool
                    </Typography>

                    <Box>
                        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                            <div>
                                <Box sx={{}}>
                                    <TextField
                                        sx={{
                                            margin: "0.25rem",
                                            width: "11rem", input: { color: 'white' },
                                            label: { color: 'white' }
                                        }}
                                        id="gbpInPool"
                                        label="Gbp In Pool"
                                        defaultValue={gbpInPool}
                                        variant='filled'
                                        onChange={handleGbpInPoolChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                                <Box sx={{}}>
                                    <TextField
                                        sx={{
                                            margin: "0.25rem",
                                            width: "11rem", input: { color: 'white' },
                                            label: { color: 'white' }
                                        }}
                                        id="memberSlots"
                                        label="Member Slots"
                                        defaultValue={memberSlots}
                                        variant='filled'
                                        onChange={handleMemberSlotsChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                                <Box sx={{}}>
                                    <TextField
                                        sx={{
                                            margin: "0.25rem",
                                            width: "11rem", input: { color: 'white' },
                                            label: { color: 'white' }
                                        }}
                                        id="latestNewsletterId"
                                        label="Live Newsletter Id"
                                        defaultValue={latestNewsletterId}
                                        variant='filled'
                                        onChange={handleLatestNewsletterIdChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="info"
                                    sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.0rem", marginBottom: "0.75rem" }}>
                                    Save
                                </Button>
                            </div>
                        </form>
                    </Box>

                </Box>
            </Box>
            <DashboardLogoutFooterComponent />
        </>
    );
}

export default AdminDashboardPool;
